import {LOCATE_DIMENSIONS_APP} from "../types";

const dimensionsApp= (dimensions) => {
  return ({type: LOCATE_DIMENSIONS_APP, payload: {dimensionsApp: dimensions}});
};
export default dimensionsApp;